export function marker<T>(value: T): T {
  return value;
}
